export default __webpack_public_path__ + "locales/tr/Notifications.json?hash=bfa6e8f2e413a1b585956bdfaefe34f7";